import { PaymentBubble } from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function WaitForaccountTransferDepositBubble({
  chatMessage,
  history
}: PaymentBubbleCommonProps) {
  const totalAmount = (chatMessage?.rfq?.purchaseAmount ?? 0).toLocaleString(
    'ko'
  );
  const onClickButton = () => {
    if (!history) return;
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble>
      <PaymentBubble.Title>입금 대기중입니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={1} />
      <PaymentBubble.Content>
        고객님이 요청한 제조서비스를 파트너가 시작할 수 있도록 캐파 가상계좌로
        결제 대금을 입금해주세요.
      </PaymentBubble.Content>
      <PaymentBubble.Content>
        총 결제금액 : {totalAmount}원
      </PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
